/**
 *
 * @author Aleynikov Boris <aleynikov.boris@gmail.com>.
 */

'use strict';

var app                  = require('mag-app'),
    icons                = require('magcore-theme/icons'),
    format               = require('cjs-format'),
    $img                 = document.createElement('img'),
    $pageMain            = document.getElementById('pageMain'),
    $canvas              = document.getElementById('pageMainCanvas'),
    $censoredPlaceholder = document.getElementById('previewCensoredPlaceholder'),
    $channelsListTitle   = document.getElementById('channelListTitle'),
    $channelsListCount   = document.getElementById('channelsCount'),
    $currentEpgWrapper   = document.getElementById('pageMainCurrentChannelEpg'),
    $currentEpg          = $currentEpgWrapper.children[0],
    $currentEpgCensored  = $currentEpgWrapper.children[1],
    $channelListNoData   = document.getElementById('channelListNoDataWrapper'),
    ctx                  = $canvas.getContext('2d'),
    coords               = app.metrics.canvasPosition,
    $coloredDiv           = document.createElement('div'),
    $styleTag             = document.createElement('style'),
    $rightArrow          = document.createElement('div'),
    $leftArrow           = document.createElement('div'),
    $lockIcon            = document.createElement('span'),
    styledTextColor;
    // imgUrl;

const {
    RIGHT_ARROW_CLICK,
    LEFT_ARROW_CLICK
} = require('./events');


function getElementStyles ( $element ) {
    var sheets = document.styleSheets,
        styleLength = document.styleSheets.length,
        nodeName = $element.nodeName.toLowerCase(),
        styles = [],
        styleIndex = 0,
        rules, ruleIndex, ruleLength;

    while ( styleIndex < styleLength ) {
        rules = sheets[styleIndex].rules || sheets[styleIndex].cssRules;

        // window.top.console.log(styleIndex + ' - styleIndex');
        ruleIndex = 0;
        ruleLength = rules.length;

        while ( ruleIndex < ruleLength ) {
            // window.top.console.log(ruleIndex + ' - ruleIndex');
            // window.top.console.log('selector finded?');
            // window.top.console.log(nodeName.indexOf(rules[ruleIndex].selectorText) !== -1);
            if ( nodeName.indexOf(rules[ruleIndex].selectorText) !== -1 ) {
                // window.top.console.log('push style ' + rules[ruleIndex].style.cssText);
                styles.push(rules[ruleIndex].style);
            }

            ++ruleIndex;
            // window.top.console.log(ruleIndex + ' - ruleIndex2');
        }

        ++styleIndex;
    }

    // window.top.console.log('return styles ' + styles.length);
    return styles;
}


function normalizeLink ( link ) {
    return link.replace('url("', '').replace('")', '')
        .replace('url', '').replace('(', '').replace(')', '');
}


function detectAndroidDevice () {
    return core.device && core.device.name
        && ['emulator', 'emulator_stb', 'AndroidAPP', 'AndroidSTB'].indexOf(core.device.name) > -1;
}

function resolveImage ( url ) {
    // canvas
    // .replace('url("', '').replace('")', '')
    // .replace('url', '').replace('(', '').replace(')', '');

    // window.top.console.log('bgImage: ' + window.getComputedStyle(document.body).backgroundImage);

    // floating
    $img.onload = function () {
        var base64ImageString;

        // window.top.console.log('image onload');

        ctx.drawImage($img, 0, 0);
        ctx.clearRect(coords.x, coords.y, coords.width, coords.height);

        if ( $canvas.toDataURL && detectAndroidDevice() ) {
            base64ImageString = $canvas.toDataURL();
            ctx.clearRect(0, 0, app.metrics.width, app.metrics.height);
            $canvas.style.backgroundImage = 'url(' + base64ImageString + ')';
        }

        $canvas.appendChild($img);

        module.exports.canvasLoaded = true;

        app.emit('background:load');
    };

    $img.onerror = function ( ) {
        var styles = getElementStyles(document.body),
            index = 0;

        while ( index < styles.length ) {
            if ( styles[index].backgroundImage ) {
                resolveImage(normalizeLink(styles[index].backgroundImage));
                break;
            }

            ++index;
        }
    };

    $img.src = url;
}

// huck to get color from class
// when backend will supports new way of json wars should replace with core.theme[varName] to get color;
$coloredDiv.className = 'theme-styled-text';
document.body.appendChild($coloredDiv);
styledTextColor = window.getComputedStyle($coloredDiv).color;
//damn hardcode css style:)
$styleTag.innerText = '.classic-tv-special-bg {' +
    'background-color:' + styledTextColor + '}\n' +
    '#pageDetails .mag-component-list.right-side .item.focus div .container {' +
    'background-color: ' + styledTextColor + ';}\n' +
    '#pageDetails .mag-component-list.right-side.focus .item.focus div .text {' +
    'color: ' + styledTextColor + ';}';

document.head.appendChild($styleTag);
$channelListNoData.children[0].innerText = gettext('No channels');

$rightArrow.className = 'container-arrow-right';
$rightArrow.innerText = '\\\n/';

$leftArrow.className = 'container-arrow-left';
$leftArrow.innerText = '/\n\\';

$pageMain.appendChild($rightArrow);
$pageMain.appendChild($leftArrow);

$rightArrow.addEventListener('click', function () {
    app.emit(RIGHT_ARROW_CLICK);
});

$leftArrow.addEventListener('click', function () {
    app.emit(LEFT_ARROW_CLICK);
});

$canvas.width = app.metrics.width;
$canvas.height = app.metrics.height;
// censored placeholder
$censoredPlaceholder.className += ' ' + icons.LOCK;
$lockIcon.className = icons.LOCK;

$currentEpgCensored.appendChild($lockIcon);
$currentEpgCensored.innerHTML += gettext('Channel is censored');

resolveImage(normalizeLink(window.getComputedStyle(document.body).backgroundImage));

module.exports = {
    /**
     * State is app ui in preview mode
     */
    preview: true,

    /**
     * Show / hide preview mode for main page
     *
     * @param {boolean} state to show preview mode
     */
    showPreview: function ( state ) {
        if ( state ) {
            document.body.classList.add('background-off');
            $pageMain.classList.remove('page-full-list');
        } else {
            document.body.classList.remove('background-off');
            $pageMain.classList.add('page-full-list');
        }
        this.preview = !!state;
    },

    /**
     * Show placeholder for parent locked channels
     */
    showCensoredPlaceholder: function () {
        $censoredPlaceholder.classList.remove('hidden');
        $currentEpgWrapper.classList.add('censored');
    },

    /**
     * Hide placeholder for censored channels
     */
    hideCensoredPlaceholder: function () {
        $censoredPlaceholder.classList.add('hidden');
        $currentEpgWrapper.classList.remove('censored');

    },

    colors: {
        SPECIAL_BACKGROUND: styledTextColor
    },

    updateFloatingPanel: require('./floating.panel')({specialColor: styledTextColor}),

    hideFloatingPanel: function () {
        window.floatingPanel.classList.add('hidden');
    },
    showFloatingPanel: function () {
        window.floatingPanel.classList.remove('hidden');
    },

    updateChannelsListTitle: function ( tvConfig, genresList ) {
        var genre;

        if ( !tvConfig.genre && !tvConfig.search ) {
            $channelsListTitle.innerText = gettext('Channel list');
        } else if ( tvConfig.genre && tvConfig.search ) {
            genre = genresList.filter(function ( genreItem ) { return genreItem.id === tvConfig.genre; })[0].name || '';
            $channelsListTitle.innerText = gettext('Search') + ' ' + gettext('in') + ' ' + genre +
                ' ' + gettext('by') + ' "' + tvConfig.search + '"';
        } else if ( tvConfig.genre ) {
            genre = genresList.filter(function ( genreItem ) { return genreItem.id === tvConfig.genre; })[0].name || '';
            $channelsListTitle.innerText = genre;
        } else if ( tvConfig.search ) {
            $channelsListTitle.innerText = gettext('Search') + ' ' + gettext('by') + ' "' + tvConfig.search + '"';
        }
    },

    updateChannelsListCount: function ( count ) {
        var plural = window.ngettext('{0} channel', '{0} channels', count);

        $channelsListCount.innerText = format(plural || '{0} channels', count);

        if ( count ) {
            $channelListNoData.classList.remove('visible');
            if ( this.preview ) {
                document.body.classList.add('background-off');
            }
        } else {
            $channelListNoData.classList.add('visible');
            if ( this.preview ) {
                document.body.classList.remove('background-off');
            }
        }
    },

    updateCurrentChannelEpg: function ( data ) {
        data = data || [];

        $currentEpg.innerText = data.filter(function ( item ) {
            var nowTime   = new Date(),
                startTime = new Date(item.start * 1000),
                endTime   = new Date(item.end * 1000);

            return startTime > nowTime || ( startTime < nowTime && endTime > nowTime );
        }).slice(0, 5).map(function ( item ) {
            return new Date(item.start * 1000).toTimeString().replace(/.*(\d{2}:\d{2})(:\d{2}).*/, '$1') + ' - ' + item.title;
        }).join('\n');

    },

    canvasLoaded: false
};
